// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-apk-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

@media (max-width: 768px) {
  .update-apk-grid {
    grid-template-columns: 1fr;
  }
}

.update-apk-card {
  background: #fff;
  border-radius: var(--radius, 8px);
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.update-apk-card__title {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: #0f172a;
}

.update-apk-version-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.update-apk-version-row:last-of-type {
  border-bottom: none;
}

.update-apk-file-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
  max-width: min(100%, 260px);
  text-align: right;
}

.update-apk-meta-hint {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}

.update-apk-meta-error {
  margin: 0;
  color: #dc2626;
  font-size: 0.9rem;
  font-weight: 500;
}

.update-apk-apk-path {
  font-size: 0.8rem;
  color: #475569;
  word-break: break-all;
  text-align: right;
  max-width: 100%;
}

.update-apk-download {
  font-size: 0.85rem;
  font-weight: 600;
  color: #0f766e;
  text-decoration: none;
}

.update-apk-download:hover {
  text-decoration: underline;
}

.update-apk-version-label {
  color: #64748b;
  font-size: 0.9rem;
}

.update-apk-version-value {
  font-weight: 600;
  color: #0f766e;
  font-size: 1rem;
}

.update-apk-badge {
  margin-top: 1rem;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
}

.update-apk-badge--force {
  background: #fef3c7;
  color: #92400e;
}

.update-apk-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.update-apk-dropzone {
  position: relative;
  min-height: 140px;
  border: 2px dashed #cbd5e1;
  border-radius: var(--radius, 8px);
  padding: 1.5rem;
  text-align: center;
  transition: border-color 0.2s, background 0.2s;
}

.update-apk-dropzone:hover,
.update-apk-dropzone--active {
  border-color: #0d9488;
  background: #f0fdfa;
}

/* Full-area hit target so macOS/Safari file picker opens reliably */
.update-apk-file-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.update-apk-dropzone-visual {
  position: relative;
  z-index: 1;
  pointer-events: none;
  color: #64748b;
  font-size: 0.9rem;
}

.update-apk-browse-btn {
  align-self: flex-start;
  padding: 0.45rem 0.95rem;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #f0fdfa;
  border: 1px solid #99f6e4;
  border-radius: 6px;
  cursor: pointer;
}

.update-apk-browse-btn:hover:not(:disabled) {
  background: #ccfbf1;
}

.update-apk-browse-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.update-apk-dropzone-icon {
  display: block;
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.update-apk-filename {
  color: #0f766e;
  font-weight: 500;
}

.update-apk-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.update-apk-field-label {
  font-size: 0.85rem;
  color: #475569;
  font-weight: 500;
}

.update-apk-input {
  padding: 0.6rem 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.95rem;
}

.update-apk-input:focus {
  outline: none;
  border-color: #0d9488;
  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.2);
}

.update-apk-submit {
  padding: 0.65rem 1.25rem;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  align-self: flex-start;
}

.update-apk-submit:hover {
  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);
}

.update-apk-submit:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.update-apk-error {
  margin: 0;
  font-size: 0.9rem;
  color: #dc2626;
  font-weight: 500;
}

.update-apk-success {
  margin: 0;
  font-size: 0.9rem;
  color: #059669;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/UpdateApk/UpdateApkPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".update-apk-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n@media (max-width: 768px) {\n  .update-apk-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.update-apk-card {\n  background: #fff;\n  border-radius: var(--radius, 8px);\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.update-apk-card__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.update-apk-version-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.update-apk-version-row:last-of-type {\n  border-bottom: none;\n}\n\n.update-apk-file-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n  max-width: min(100%, 260px);\n  text-align: right;\n}\n\n.update-apk-meta-hint {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.update-apk-meta-error {\n  margin: 0;\n  color: #dc2626;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.update-apk-apk-path {\n  font-size: 0.8rem;\n  color: #475569;\n  word-break: break-all;\n  text-align: right;\n  max-width: 100%;\n}\n\n.update-apk-download {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #0f766e;\n  text-decoration: none;\n}\n\n.update-apk-download:hover {\n  text-decoration: underline;\n}\n\n.update-apk-version-label {\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.update-apk-version-value {\n  font-weight: 600;\n  color: #0f766e;\n  font-size: 1rem;\n}\n\n.update-apk-badge {\n  margin-top: 1rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.update-apk-badge--force {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.update-apk-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.update-apk-dropzone {\n  position: relative;\n  min-height: 140px;\n  border: 2px dashed #cbd5e1;\n  border-radius: var(--radius, 8px);\n  padding: 1.5rem;\n  text-align: center;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.update-apk-dropzone:hover,\n.update-apk-dropzone--active {\n  border-color: #0d9488;\n  background: #f0fdfa;\n}\n\n/* Full-area hit target so macOS/Safari file picker opens reliably */\n.update-apk-file-input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.update-apk-dropzone-visual {\n  position: relative;\n  z-index: 1;\n  pointer-events: none;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.update-apk-browse-btn {\n  align-self: flex-start;\n  padding: 0.45rem 0.95rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #f0fdfa;\n  border: 1px solid #99f6e4;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.update-apk-browse-btn:hover:not(:disabled) {\n  background: #ccfbf1;\n}\n\n.update-apk-browse-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.update-apk-dropzone-icon {\n  display: block;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.update-apk-filename {\n  color: #0f766e;\n  font-weight: 500;\n}\n\n.update-apk-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.update-apk-field-label {\n  font-size: 0.85rem;\n  color: #475569;\n  font-weight: 500;\n}\n\n.update-apk-input {\n  padding: 0.6rem 0.85rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.95rem;\n}\n\n.update-apk-input:focus {\n  outline: none;\n  border-color: #0d9488;\n  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.2);\n}\n\n.update-apk-submit {\n  padding: 0.65rem 1.25rem;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  align-self: flex-start;\n}\n\n.update-apk-submit:hover {\n  background: linear-gradient(135deg, #0d9488 0%, #2dd4bf 100%);\n}\n\n.update-apk-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.update-apk-error {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #dc2626;\n  font-weight: 500;\n}\n\n.update-apk-success {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #059669;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
